/**
 * Turn a compact `DetectorRecord` (from `extensions/generated-records.json`) into a full
 * `ExtensionDefinition`. This is what lets the detector set scale to thousands of
 * extensions without a hand-written module for each — the straightforward resource-probe
 * ones are data, and this is the one generic prober that runs them.
 */

import { probeFetch, probeImage } from './probe';
import type { DetectorRecord, ExtensionDefinition } from './types';

export function fromRecord(r: DetectorRecord): ExtensionDefinition {
  return {
    id: r.id,
    name: r.name,
    storeUrl: `https://chromewebstore.google.com/detail/${r.id}`,
    users: r.users,
    requiredOrigin: r.requiredOrigin,
    notes:
      'Generated resource-probe detector (tooling/generate-detectors.js). Promote it to a ' +
      'hand-written module for anything needing bespoke logic or explanation.',
    signals: r.resources.map((res, i) => ({
      id: `war-${i}-${(res.path.split('/').pop() || String(i))
        .replace(/[^a-z0-9]+/gi, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 28)
        .toLowerCase()}`,
      kind: 'web-accessible-resource' as const,
      description: `Fetch ${res.path} — a web-accessible resource exposed ${
        r.requiredOrigin ? `to ${r.requiredOrigin}` : 'to every origin'
      }.`,
      weight: res.weight,
      run: () => (res.image ? probeImage(r.id, res.path) : probeFetch(r.id, res.path)),
    })),
  };
}
